import { formatCompactNumber, formatWithCommas } from "./format";

const STAT_CARD_META = {
  input_tokens: { label: "Input tokens", icon: "download", compact: true },
  output_tokens: { label: "Output tokens", icon: "upload", compact: true },
  total_credits: { label: "Total credits", icon: "credits", compact: false },
};

function initialsOf(name) {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function transformStatCards(statCards) {
  return Object.entries(STAT_CARD_META).map(([key, meta]) => {
    const stat = statCards[key] || { value: 0, change_pct: 0, trend: "up" };
    return {
      key,
      label: meta.label,
      icon: meta.icon,
      displayValue: meta.compact
        ? formatCompactNumber(stat.value)
        : formatWithCommas(stat.value),
      changePct: stat.change_pct,
      trend: stat.trend,
    };
  });
}

export function transformTokenUsageTrend(trend) {
  return trend.map((row) => ({
    month: row.month,
    input: row.input,
    output: row.output,
  }));
}

export function transformUsers(users) {
  return users.map((u) => ({
    id: u.id,
    name: u.name,
    email: u.email,
    initials: initialsOf(u.name),
    plan: u.plan,
    billing: u.billing,
    inputTokens: u.input_tokens,
    outputTokens: u.output_tokens,
    remainingTokens: u.remaining_tokens,
    remainingCredits: u.remaining_credits,
    remainingCreditsCap: u.remaining_credits_cap,
  }));
}

export function transformPackageHistory(history) {
  return history.map((row) => ({
    date: row.date,
    package: row.package,
    tokensAllocated: row.tokens_allocated,
    tokensRemaining: row.tokens_remaining,
    status: row.status,
  }));
}
